module.exports = __webpack_public_path__ + "img/banner-img-new-phone.a92d7ff8.png";